import type { PerUnitProduct } from '@weft/services';
import { isPerUnitProductVariant } from '@weft/services';
import { isPerUnitUsageProductOnly } from '@weft/services';
import type { UsageLineItem } from '@weft/types';
import { raise, validateNotEmptyString } from '@weft/utils';
import React from 'react';
import { useInvoiceCurrency } from '../../../../../../hooks/use-invoice-currency';
import { getProductTitle } from '../../../../../../services/product/product-title';
import { InvoicePerUnitUsageChargeItem } from './InvoicePerUnitUsageChargeItem';

type InvoicePerUnitUsageChargesProps = {
  lineItems: UsageLineItem[]
};

export const InvoicePerUnitUsageCharges: React.FC<InvoicePerUnitUsageChargesProps> = ({
  lineItems,
}) => {
  const currency = useInvoiceCurrency(lineItems);

  return (
    <div className="space-y-5">
      {lineItems.map(({ lineItemProduct, tiersUsageMap }, index) => {
        if (!isPerUnitUsageProductOnly<PerUnitProduct>(lineItemProduct)) {
          raise('Invalid product type');
        }

        return (
          <div
            key={index}
            className="rounded-2lg border-line flex flex-col gap-y-4 border p-5"
          >
            {lineItemProduct.variants.map(productVariant => {
              validateNotEmptyString(productVariant.productVariantId, 'productVariantId');

              if (!isPerUnitProductVariant(productVariant)) {
                raise('Invalid product variant type');
              }
              
              return (
                <InvoicePerUnitUsageChargeItem
                  key={productVariant.productVariantId}
                  name={getProductTitle(lineItemProduct)}
                  pricePerUnit={productVariant.pricing.priceConfiguration.price}
                  totalPrice={tiersUsageMap[productVariant.productVariantId][0].price}
                  units={tiersUsageMap[productVariant.productVariantId][0].periodUnits}
                  currency={currency}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
